export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            关于每日大瓜
          </h2>
          <p className="text-sm text-foreground-500">
            不生产瓜，只做全网最全的瓜田守望者
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="prose prose-sm max-w-none">
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              每日大瓜诞生于吃瓜文化盛行的互联网时代，我们深知每一个"瓜友"对于每日爆料吃瓜与吃瓜每日新鲜感的渴望。作为一个专注娱乐爆料与网友爆料的聚合平台，我们不做原创报道，而是像勤劳的瓜农一样，每天从全网 30+ 信源渠道中精挑细选最值得关注的内容，以文字截图摘要的形式呈现给你。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              从明星八卦到综艺热点，从网红翻车到行业大瓜，从社会猛料到圈内秘闻——只要是值得吃的瓜，我们一个都不放过。平台保持每日更新，内容天天不重样，确保你每次打开都有新的爆料合集可以享用。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              我们坚持轻量化呈现、多源交叉验证、严格匿名保护的原则。每日大瓜提供的内容仅供娱乐参考，不构成事实认定。吃瓜虽好，可不要贪杯哦——理性吃瓜，快乐生活。
            </p>
          </div>

          <div className="mt-6 pt-6 border-t border-background-200/70 flex flex-wrap gap-4 text-xs text-foreground-400">
            <span>📅 创立于 2024 年</span>
            <span>📰 累计聚合 50,000+ 条爆料</span>
            <span>👥 服务百万吃瓜群众</span>
          </div>
        </div>
      </div>
    </section>
  );
}